export default __webpack_public_path__ + "static/article-renovation-hiring-builder-0c38dc1dc3bd4485a99ea1205d1e8a7a.jpg";